import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import Moment from 'react-moment'
import * as rest from '../../services'
import { reduxForm, change } from 'redux-form'
import {FormButtons, PrintHOC} from '../../components'
import { Slider } from '../../components'
import {LoanerDeviceAgreement} from './prints'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'
import { ESignaturePane } from '../ESignature'
import moment from "moment";
const FORM_NAME = 'LoanerRecordForm'
let LoanerRecordForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  dispatch,
  ticket,
}) => {
  const [availableInventoryItems, setAvailableInventoryItems] = useState([])

  const onSelectionChanged = (item) => {
    dispatch(change(FORM_NAME, 'inventory_item', item.url))
  }

  const onFilter = (payload) => {
    rest.TicketService.call_url_action(
      `${ticket.url}get_applicable_loaner_devices/`,
      'GET',
      payload
    )
      .then((response) => {
        setAvailableInventoryItems(response)
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <components.SelectableTable
          myChangeHandler={true}
          onFilter={onFilter}
          columns={[
            {
              dataField: 'serial_number',
              text: 'Product Name',
            },
            {
              dataField: 'part_number',
              text: 'Product Price',
            },
            {
              dataField: 'description',
              text: 'Description',
            },
            {
              dataField: 'created_by',
              text: 'Created By',
            },
          ]}
          items={availableInventoryItems}
          OnSelectionChanged={onSelectionChanged}
        />
      </div>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
LoanerRecordForm = reduxForm({
  form: FORM_NAME,
})(LoanerRecordForm)

const LoanerAgreementSlider = ({ ticket, loanerRecord }) => {
  const LoanerDeviceAgreementPrint = PrintHOC(LoanerDeviceAgreement,  <span className="m-3">
          <ESignaturePane
            id={loanerRecord.id}
            guid={loanerRecord.guid}
            url={loanerRecord.url}
            type="loaner_record"
            code={ticket.reference_number}
          ></ESignaturePane>
        </span>)
  return (
    <Slider size={"md"} variant="success" title="Agreement">
      <LoanerDeviceAgreementPrint ticket={ticket} record={loanerRecord}>

      </LoanerDeviceAgreementPrint>
    </Slider>
  )
}
const LoanerRecordReturnButton = ({ loanerRecord, onReturn }) => {

  const dispatch = useDispatch()
  let onReturnConfirm = function () {
    new rest.LoanerRecordService(loanerRecord.url)
      .mark_return()
      .then((response) => {
        onReturn(response)
        dispatch(showSuccessToast('Success', 'Loaner Device returned.'))
      })
      .catch((errors) => {
        console.error(errors)
        dispatch(showErrorToast('Error', 'Could not mark Loaner Device returned.'))
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={onReturnConfirm}
        body="Are you sure you want to return this item?"
        confirmText="Confirm return item"
        confirmBSStyle="danger"
        title="Confirm return item"
      >
        <ReactBootstrap.Button
          disabled={loanerRecord.returned_on}
          variant="dark"
          eventKey="1"
        >
          {components.ICONS.DELETE} Return
        </ReactBootstrap.Button>
      </components.Confirm>
    </>
  )
}

const LoanerRecordCancelButton = ({ loanerRecord, onReturn, onError }) => {
    const currentTime = moment();
    const targetTime = moment(loanerRecord.created_at);

    // // Get the time zone offset in minutes for the current time
    // const currentTimezoneOffset = currentTime.utcOffset();
    //
    // // Adjust the target time by adding the time zone offset in minutes
    // targetTime.add(currentTimezoneOffset, 'minutes');

    // Calculate the time difference in hours
    const hoursDifference = currentTime.diff(targetTime, 'hours');



  const dispatch = useDispatch()
  let onCancelConfirm = function () {
    new rest.LoanerRecordService(loanerRecord.url)
      .mark_cancel()
      .then((response) => {
        onReturn(response)
        dispatch(showSuccessToast('Success', 'Loaner Device canceled.'))
      })
      .catch((errors) => {
        console.error(errors)
        dispatch(showErrorToast('Error', 'Could not mark Loaner Device returned.'))
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={onCancelConfirm}
        body="Are you sure you want to cancel this item?"
        confirmText="Confirm cancel item"
        confirmBSStyle="danger"
        title="Confirm cancel item"
      >
        <ReactBootstrap.Button
          disabled={loanerRecord.returned_on || hoursDifference>=6}
          variant="warning"
          eventKey="1"
        >
          {components.ICONS.CLOSE} Cancel
        </ReactBootstrap.Button>
      </components.Confirm>
    </>
  )
}



const LoanerRecordLostButton = ({ ticket, loanerRecord, onReturn }) => {
  const dispatch = useDispatch()
  let onReturnConfirm = function () {
    new rest.LoanerRecordService(loanerRecord.url)
      .mark_lost()
      .then((response) => {
        onReturn(response)

        dispatch(showErrorToast('Success', 'Loaner Device marked lost.'))
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={onReturnConfirm}
        body="Are you sure you want to mark Lost this item?"
        confirmText="Confirm return item Lost"
        confirmBSStyle="danger"
        title="Confirm return item Lost"
      >
        <ReactBootstrap.Button
          disabled={loanerRecord.returned_on}
          variant="danger"
          eventKey="1"
        >
          {components.ICONS.DELETE} Mark Lost
        </ReactBootstrap.Button>
      </components.Confirm>
    </>
  )
}

const LoanerRecordEmailButton = ({ loanerRecord }) => {
  const dispatch = useDispatch()
  let onReturnConfirm = function () {
    new rest.LoanerRecordService(loanerRecord.url)
      .send_record_details_by_email()
      .then((response) => {
        dispatch(
          showSuccessToast('Success', 'Loaner Device Details sent over mail.')
        )
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={onReturnConfirm}
        body="Are you sure you want to send email?"
        confirmText="Confirm Send Email"
        confirmBSStyle="danger"
        title="Confirm Email"
      >
        <ReactBootstrap.Button
          disabled={loanerRecord.returned_on}
          variant="primary"
          eventKey="1"
        >
          {components.ICONS.EMAIL} Send Email
        </ReactBootstrap.Button>
      </components.Confirm>
    </>
  )
}

const LoanerRecord = ({ loanerRecord, ticket, onTicketUpdate }) => {
  const onUpdate=(lr)=>{

   const loaner_records = ticket.loaner_records.map((l) => {
           return l.url === loanerRecord.url ? lr : l
       }
      )
   const t = {...ticket,loaner_records:loaner_records}
      onTicketUpdate(t)
  }
  return (
    <ReactBootstrap.Row>
      <ReactBootstrap.Col className="p-0" xs="6">
        <strong>Serial: {loanerRecord.inventory_item_serial_number}-</strong>
        <sub>
          <Moment fromNow>{loanerRecord.created_at}</Moment>
        </sub>
        <br />
        <strong>Description :</strong>
        {loanerRecord.inventory_item_description}
      </ReactBootstrap.Col>
      <ReactBootstrap.Col className="p-0 text-end" xs="6">
      <span className="me-1"> <LoanerAgreementSlider loanerRecord={loanerRecord} ticket={ticket} /></span>
      <span className="me-1">  <LoanerRecordReturnButton
          onReturn={onUpdate}
          loanerRecord={loanerRecord}
          ticket={ticket}
        /></span>
       <span className="me-1"> <LoanerRecordLostButton
          onReturn={onUpdate}
          loanerRecord={loanerRecord}
          ticket={ticket}
        /></span>
             <span className="me-1"> <LoanerRecordCancelButton
          onReturn={onUpdate}
          loanerRecord={loanerRecord}
          ticket={ticket}
        /></span>

       <span className="me-1"> <LoanerRecordEmailButton
          loanerRecord={loanerRecord}
          ticket={ticket}
        /></span>
      </ReactBootstrap.Col>
    </ReactBootstrap.Row>
  )
}

export const TicketLoanerRecords = ({ ticket, onTicketUpdate }) => {
  const dispatch = useDispatch()
  const createLoanerRecord = (values) => {
    values.ticket = ticket.url
    new rest.LoanerRecordService()
      .makePostRequest(values)
      .then((response) => {
        onTicketUpdate({...ticket,loaner_records:[response,...ticket.loaner_records]})
        dispatch(showSuccessToast('Success', 'Ticket loaner record created.'))
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }

  return (
    <ReactBootstrap.Card className="mt-5">
      <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs="6">Loaner Records</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-end" xs="6">
            <Slider
              title={components.ICONS.PLUS}
              header={
                <>
                  <span className="mr-3">{components.ICONS.PLUS}</span>
                  <span>Add Loaner Records</span>
                </>
              }
            >
              <LoanerRecordForm ticket={ticket} onSubmit={createLoanerRecord} />
            </Slider>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Title>
      <ReactBootstrap.Card.Body>
        <div>
          {ticket.loaner_records.length ? (
            <components.ItemList
              className="mt-5"
              itemRenderer={(index, key) => {
                return (
                  <ReactBootstrap.Col key={ticket.loaner_records[index].url}>
                    <LoanerRecord
                      ticket={ticket}
                      onTicketUpdate={onTicketUpdate}
                      loanerRecord={ticket.loaner_records[index]}
                    />
                  </ReactBootstrap.Col>
                )
              }}
              length={ticket.loaner_records.length}
            />
          ) : (
            <ReactBootstrap.Alert variant={'info'}>
              No previous Loaner Record found.
            </ReactBootstrap.Alert>
          )}
        </div>
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
